import React from 'react'

export const Tab = ({tab, index, children}) => {
  return <>
    {tab === index ? children : null}
  </>
};
